import { BusEvent } from '@web/common';

export class AdminBannerCreatedBusEvent extends BusEvent {}
